import { useCallback, useState, useEffect } from "react";
import { getRequest } from "../config";


const useAdCardData = (sectionNo = "D002") => {

    const [data, setData] = useState({})
    const [adId, setAdId] = useState(null)
    const [loading, setLoading] = useState(false)
    const [fetchedSectionNo, setFetchedSectionNo] = useState(null)

    const fetchData = useCallback(async () => {
        setLoading(true)
        try {
            const response = await getRequest(`/modules/temp-sections/${sectionNo}/ads`, {}, setData)
            // Reason: empty ads list must clear previous section card so UserAdCard does not keep showing stale/default data.
            if (response.body && response.body.length) {
                setData({ ...response.body[0].advisor, isDefault: response.body[0]?.isDefault ?? false, company: { logo: response.body[0]['company']?.['logo'] ?? null }, _id: response.body[0]['advisorId'] });
                setAdId(response.body[0]._id)
            } else {
                setData({})
                setAdId(null)
            }
            setFetchedSectionNo(sectionNo)
        } catch (error) {
            setData({})
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false)
        }
    }, [sectionNo]);

    useEffect(() => {
        if (sectionNo) {
            fetchData()
        }
    }, [sectionNo])

    return { data, adId, loading, fetchedSectionNo }
}

export default useAdCardData;